import { FC, useCallback } from 'react';
import { DistrictsModal } from '../../../../../../packages/GeoComponents';
import { useSelector } from 'react-redux';
import { selectIncludeNewMoscow } from 'shared/selectors/jsonQuery';

import { selectLocation } from 'shared/selectors/location';
import { useAppDispatch, useJsonQueryBackup } from 'shared/hooks';
import { SearchButtonContainer } from '../../SearchButtonContainer';
import { selectDistrictsSwitcher } from 'shared/selectors/geo';
import { setIncludeNewMoscow } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from 'shared/thunks/searchMeta';
import { applyFilters } from 'shared/thunks/filters';
import { updateTags } from 'shared/thunks/tags';
import { removeDistrict, selectDistrict } from 'shared/thunks/geo/districtsSwitcher';

interface IDistrictsModalContainerProps {
  onModalClose: VoidFunction;
}

export const DistrictsModalContainer: FC<IDistrictsModalContainerProps> = ({ onModalClose }) => {
  const dispatch = useAppDispatch();
  const currentLocation = useSelector(selectLocation);
  const includeNewMoscow = useSelector(selectIncludeNewMoscow);
  const { isLoading, districts, selectedDistricts } = useSelector(selectDistrictsSwitcher);
  const { resetJsonQuery } = useJsonQueryBackup();

  const handleApply = useCallback(() => {
    onModalClose();
    dispatch(applyFilters());
    dispatch(updateTags(true));
  }, [dispatch, onModalClose]);

  const handleSelect = useCallback(
    (id: number, name: string) => {
      dispatch(selectDistrict({ id, name }));
    },
    [dispatch],
  );

  const handleRemove = useCallback(
    (id: number) => {
      dispatch(removeDistrict(id));
    },
    [dispatch],
  );

  const handleNewMoscowSwitched = useCallback(
    (includeNewMoscow: boolean | null) => {
      dispatch(setIncludeNewMoscow(includeNewMoscow));
      dispatch(updateSearchMeta());
    },
    [dispatch],
  );

  const handleClose = useCallback(() => {
    onModalClose();
    resetJsonQuery();
  }, [onModalClose, resetJsonQuery]);

  return (
    <DistrictsModal
      selectedLocation={currentLocation}
      isDataLoading={isLoading}
      districts={districts}
      selectedDistricts={selectedDistricts}
      includeNewMoscow={includeNewMoscow}
      onClose={handleClose}
      onNewMoscowSwitched={handleNewMoscowSwitched}
      onRemoved={handleRemove}
      onSelected={handleSelect}
      searchButton={<SearchButtonContainer onClick={handleApply} />}
    />
  );
};
